// ============================================================================
// FILE: src/modules/ticket/components/sla/SLAViolationsTable.js
// UPDATED: 2025-12-14
// PURPOSE: SLA Violations Table with i18n (fixed: t is not a function)
// ============================================================================

import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function SLAViolationsTable({ title, data }) {
  const { t } = useTranslation();

  const items = Array.isArray(data) ? data : [];

  return (
    <div
      style={{
        background: "white",
        borderRadius: "16px",
        padding: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      {/* Header */}
      <div
        style={{
          fontSize: "16px",
          fontWeight: 600,
          marginBottom: "14px",
        }}
      >
        {title || t("sla.table.violations")}
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>{t("sla.table.ticket_number", "Ticket")}</th>
              <th>{t("sla.table.title", "Title")}</th>
              <th>{t("sla.table.category", "Category")}</th>
              <th>{t("sla.table.sla_due", "SLA Due")}</th>
              <th>{t("sla.table.closed_at", "Closed At")}</th>
              <th>{t("sla.table.escalation", "Escalation")}</th>
            </tr>
          </thead>

          <tbody>
            {items.map((row) => (
              <tr key={row.ticket_id}>
                <td>{row.ticket_number}</td>
                <td>{row.title}</td>
                <td>{row.category_id}</td>
                <td>{row.sla_due_at?.substring(0, 10)}</td>
                <td>{row.closed_at?.substring(0, 10) || "-"}</td>
                <td>{row.escalation_level}</td>
              </tr>
            ))}

            {items.length === 0 && (
              <tr>
                <td colSpan="6" className="py-4 text-center text-muted">
                  {t("sla.table.no_violations", "No SLA violations")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

SLAViolationsTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
};

export default SLAViolationsTable;
